<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <tree :tree-data="treeData" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import type { TreeProps } from 'ant-design-vue'
import { ref } from 'vue'
import tree from '@/components/Tree'
const treeData = ref<TreeProps['treeData']>([
  {
    title: '一、系统设置',
    key: '0-0',
    children: [
      {
        title: 'parent 1-0',
        key: '0-0-0',
        children: [
          { title: 'leaf', key: '0-0-0-0' },
          {
            key: '0-0-0-1',
            title: '22323'
          },
          { title: 'leaf', key: '0-0-0-2' }
        ]
      },
      {
        title: 'parent 1-1',
        key: '0-0-1',
        children: [{ title: 'leaf', key: '0-0-1-0' }]
      },
      {
        title: 'parent 1-2',
        key: '0-0-2',
        children: [
          { title: 'leaf 1', key: '0-0-2-0' },
          {
            title: 'leaf 2',
            key: '0-0-2-1',
            children: [
              { title: 'leaf 1', key: '0-0-2-1-0' },
              {
                title: 'leaf 2',
                key: '0-0-2-1-1'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: '二、应用设置',
    key: '0-1',
    children: [
      {
        title: 'parent 1-0',
        key: '0-1-0',
        children: [
          { title: 'leaf', key: '0-0-0-1' },
          {
            key: '0-1-0-1',
            title: '22323'
          },
          { title: 'leaf', key: '0-1-0-2' }
        ]
      },
      {
        title: 'parent 1-1',
        key: '0-1-1',
        children: [{ title: 'leaf', key: '0-2-1-0' }]
      },
      {
        title: 'parent 1-2',
        key: '0-1-2',
        children: [
          { title: 'leaf 1', key: '0-2-2-0' },
          {
            title: 'leaf 2',
            key: '1-0-2-1',
            children: [
              { title: 'leaf 1', key: '0-2-2-1-0' },
              {
                title: 'leaf 2',
                key: '1-2-2-1-1'
              }
            ]
          }
        ]
      }
    ]
  }
])
</script>
